import { render, staticRenderFns } from "./recover-password-form.vue?vue&type=template&id=e477aa8a&scoped=true"
import script from "./recover-password-form.vue?vue&type=script&lang=js"
export * from "./recover-password-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e477aa8a",
  null
  
)

export default component.exports